import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User selected an option from the canvas upload menu',
  name: 'canvas_upload_option_selected',
  params: [
    {
      description: 'Which upload action was taken',
      name: 'action_taken',
      required: true,
      type: 'enum',
      values: ['upload_from_computer', 'add_from_board'],
    },
    {
      description: 'Where the upload action was taken from',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['bottom_toolbar', 'context_menu', 'tool_rail_search', 'tool_rail_pinned'],
    },
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
